/**
 * Cinematic Drop — horizontal product carousel posle 3D cinematic scroll-a.
 */
(function () {
  const EASE = "cubic-bezier(0.16, 1, 0.3, 1)";

  function initDrop(section) {
    if (section.dataset.dropInit === "1") return;
    section.dataset.dropInit = "1";

    const rail = section.querySelector("[data-rail]");
    const viewport = section.querySelector("[data-viewport]");
    const cards = Array.from(section.querySelectorAll("[data-card]"));
    const panels = Array.from(section.querySelectorAll("[data-panel]"));
    const dotsHost = section.querySelector("[data-dots]");
    const prevBtn = section.querySelector("[data-nav-prev]");
    const nextBtn = section.querySelector("[data-nav-next]");
    const spotlight = section.querySelector("[data-spotlight]");

    if (!rail || !cards.length) return;

    const unified = !!document.querySelector("[data-cine-unified]");
    let index = cards.findIndex((c) => c.classList.contains("is-active"));
    if (index < 0) index = 0;

    let dragStartX = 0;
    let dragDelta = 0;
    let dragging = false;
    let moved = false;

    const clampIndex = (i) => Math.max(0, Math.min(cards.length - 1, i));

    const buildDots = () => {
      if (!dotsHost) return;
      dotsHost.innerHTML = "";
      cards.forEach((_, i) => {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "cdp__dot" + (i === index ? " is-active" : "");
        btn.setAttribute("role", "tab");
        btn.setAttribute("aria-label", "Proizvod " + (i + 1));
        btn.addEventListener("click", () => goTo(i));
        dotsHost.appendChild(btn);
      });
    };

    const updateRailOffset = () => {
      const active = cards[index];
      if (!active || !viewport) return;
      const railRect = rail.getBoundingClientRect();
      const cardRect = active.getBoundingClientRect();
      const cardCenter = cardRect.left + cardRect.width / 2;
      const railCenter = railRect.left + railRect.width / 2;
      const offset = railCenter - cardCenter;
      rail.style.transform = "translateX(" + offset.toFixed(1) + "px)";
    };

    const updateCards = () => {
      cards.forEach((card, i) => {
        const dist = Math.abs(i - index);
        card.classList.toggle("is-active", i === index);
        card.classList.toggle("is-near", dist === 1);
      });
    };

    const updatePanels = () => {
      panels.forEach((panel, i) => {
        const active = i === index;
        panel.classList.toggle("is-active", active);
        panel.setAttribute("aria-hidden", active ? "false" : "true");
      });
    };

    const updateDots = () => {
      if (!dotsHost) return;
      dotsHost.querySelectorAll(".cdp__dot").forEach((dot, i) => {
        dot.classList.toggle("is-active", i === index);
      });
    };

    const updateAccent = () => {
      const active = cards[index];
      if (!active) return;
      const accent = active.dataset.accent || "#666666";

      // Brighten dark accents so the tint still reads on a black page.
      // Black (#1a1a1a) and Olive (#3d4a32) need a much bigger white boost
      // than already-bright Beige (#c4a882) or Gold (#c9a86a).
      const hex = accent.replace("#", "");
      const r = parseInt(hex.substring(0, 2), 16) || 0;
      const g = parseInt(hex.substring(2, 4), 16) || 0;
      const b = parseInt(hex.substring(4, 6), 16) || 0;
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      // For very dark accents (black #1a1a1a, luminance ~0.10), heavy white
      // boost turned the tint silver-gray. Cap boost low so black tints
      // stay close to black with just a hair of lift — visible but not bright.
      let whiteBoost;
      if (luminance < 0.18) {
        whiteBoost = 6;
      } else {
        whiteBoost = Math.round(Math.max(10, 60 - luminance * 75));
      }
      const tinted = `color-mix(in srgb, ${accent} ${100 - whiteBoost}%, white ${whiteBoost}%)`;

      // Set the section-level tint — CSS @property + transition take care of
      // animating the radial gradient on .cdp itself.
      section.style.setProperty("--cdp-tint", tinted);

      if (spotlight) {
        spotlight.style.background =
          `radial-gradient(ellipse 70% 80% at 50% 35%, ` +
          `color-mix(in srgb, ${tinted} 55%, white 18%) 0%, ` +
          `color-mix(in srgb, ${tinted} 22%, transparent) 32%, ` +
          `transparent 72%)`;
      }
    };

    const goTo = (next) => {
      index = clampIndex(next);
      updateCards();
      updatePanels();
      updateDots();
      updateAccent();
      updateRailOffset();
    };

    cards.forEach((card, i) => {
      const hit = card.querySelector("[data-card-hit]");
      if (!hit) return;
      hit.addEventListener("click", () => {
        if (i === index) return; // active card click is a no-op
        if (moved) return;       // actual drag — pointerup already handled goTo
        goTo(i);
      });
    });

    prevBtn?.addEventListener("click", () => goTo(index - 1));
    nextBtn?.addEventListener("click", () => goTo(index + 1));

    section.querySelectorAll("[data-panel]").forEach((panel) => {
      const buyBtn = panel.querySelector("[data-buy-now]");
      const sizeBtns = panel.querySelectorAll("[data-variant-id]");
      const buyLabel = panel.querySelector("[data-buy-label]");
      const priceEl = panel.querySelector(".cdp__panel-price span");

      sizeBtns.forEach((btn) => {
        if (!btn.classList.contains("cdp__size")) return;
        btn.addEventListener("click", () => {
          panel.querySelectorAll(".cdp__size").forEach((b) => {
            b.classList.remove("is-selected");
            b.setAttribute("aria-pressed", "false");
          });
          btn.classList.add("is-selected");
          btn.setAttribute("aria-pressed", "true");
          const variantId = btn.dataset.variantId;
          const available = btn.dataset.variantAvailable === "true";
          if (buyBtn) {
            buyBtn.dataset.variantId = variantId;
            buyBtn.disabled = !available;
          }
          if (buyLabel) {
            buyLabel.textContent = available
              ? buyBtn?.dataset.defaultLabel || buyLabel.textContent
              : "Rasprodato";
          }
          if (priceEl && btn.dataset.variantPrice) {
            priceEl.textContent = btn.dataset.variantPrice;
          }
        });
      });

      if (buyBtn) {
        buyBtn.dataset.defaultLabel = buyLabel?.textContent || "Kupi";
        buyBtn.addEventListener("click", async () => {
          if (buyBtn.disabled || buyBtn.classList.contains("is-loading")) return;
          const variantId = buyBtn.dataset.variantId;
          if (!variantId) return;

          buyBtn.classList.add("is-loading");
          if (buyLabel) buyLabel.textContent = "Prebacujem...";
          try {
            const addUrl = (window.routes?.cart_add_url || "/cart/add") + ".js";
            const res = await fetch(addUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
            });
            if (!res.ok) throw new Error("cart add failed");
            window.location.href = "/checkout";
          } catch (e) {
            if (buyLabel) buyLabel.textContent = "Greška — pokušaj ponovo";
            buyBtn.classList.remove("is-loading");
            setTimeout(() => {
              if (buyLabel) buyLabel.textContent = buyBtn.dataset.defaultLabel || "Kupi";
            }, 2000);
          }
        });
      }
    });

    const onPointerDown = (e) => {
      if (e.pointerType === "mouse" && e.button !== 0) return;
      dragging = true;
      moved = false;
      dragStartX = e.clientX;
      dragDelta = 0;
      viewport?.classList.add("is-dragging");
      rail.style.transition = "none";
    };

    const onPointerMove = (e) => {
      if (!dragging) return;
      dragDelta = e.clientX - dragStartX;
      // Was 6 — too sensitive; trackpad clicks naturally jitter 5–10px and
      // were getting flagged as drags, which blocked the card-click goTo.
      if (Math.abs(dragDelta) > 12) moved = true;
      rail.style.transform = "translateX(" + (baseOffset + dragDelta).toFixed(1) + "px)";
    };

    let baseOffset = 0;

    const onPointerUp = () => {
      if (!dragging) return;
      dragging = false;
      viewport?.classList.remove("is-dragging");
      rail.style.transition = "transform 0.72s " + EASE;

      // Lighter threshold — game-feel swipe. ~5% screen width or 36px,
      // whichever is smaller. Was 12%/80px which felt sticky.
      const threshold = Math.min(window.innerWidth * 0.05, 36);
      if (dragDelta <= -threshold) goTo(index + 1);
      else if (dragDelta >= threshold) goTo(index - 1);
      else updateRailOffset();

      dragDelta = 0;
      // setTimeout(0) runs after the click event (which fires synchronously
      // after pointerup), so the click handler still sees `moved=true` for
      // real drags but ordinary taps (where moved stayed false) goTo
      // immediately. Was 40ms which lingered past clicks → double-click bug.
      setTimeout(() => { moved = false; }, 0);
    };

    /* Horizontal wheel / trackpad swipe — many users instinctively two-finger
       swipe on trackpad. Debounce so a single swipe = one card move. */
    let wheelLock = false;
    viewport?.addEventListener(
      "wheel",
      (e) => {
        if (wheelLock) return;
        const dx = e.deltaX;
        const dy = e.deltaY;
        if (Math.abs(dx) <= Math.abs(dy)) return;
        e.preventDefault();
        if (dx > 18) goTo(index + 1);
        else if (dx < -18) goTo(index - 1);
        wheelLock = true;
        setTimeout(() => { wheelLock = false; }, 420);
      },
      { passive: false }
    );

    const refreshOffset = () => {
      const active = cards[index];
      if (!active || !viewport) return;
      const viewportRect = viewport.getBoundingClientRect();
      const cardRect = active.getBoundingClientRect();
      const cardCenter = cardRect.left + cardRect.width / 2;
      const viewportCenter = viewportRect.left + viewportRect.width / 2;
      baseOffset = viewportCenter - cardCenter;
      updateRailOffset();
    };

    viewport?.addEventListener("pointerdown", onPointerDown);
    window.addEventListener("pointermove", onPointerMove);
    window.addEventListener("pointerup", onPointerUp);
    window.addEventListener("pointercancel", onPointerUp);

    window.addEventListener(
      "keydown",
      (e) => {
        if (!section.classList.contains("is-visible")) return;
        if (e.key === "ArrowLeft") goTo(index - 1);
        if (e.key === "ArrowRight") goTo(index + 1);
      },
      { passive: true }
    );

    buildDots();
    goTo(index);

    if (unified) {
      window.addEventListener("le-cine-drop", (e) => {
        const { active, fade, static: isStatic } = e.detail || {};
        if (isStatic) {
          section.classList.remove("cdp--live", "cdp--past");
          section.classList.add("cdp--static", "is-visible");
          section.style.setProperty("--cdp-fade", "1");
          requestAnimationFrame(refreshOffset);
          return;
        }
        if (active) {
          section.classList.add("cdp--live", "is-visible");
          section.classList.remove("cdp--past", "cdp--static");
          section.style.setProperty(
            "--cdp-fade",
            String(typeof fade === "number" ? fade : 1)
          );
          requestAnimationFrame(refreshOffset);
        } else {
          section.classList.remove("cdp--live", "is-visible");
        }
      });
    } else {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            section.classList.toggle("is-visible", entry.isIntersecting);
            if (entry.isIntersecting) refreshOffset();
          });
        },
        { threshold: 0.02, rootMargin: "0px 0px -4% 0px" }
      );
      io.observe(section);
    }

    window.addEventListener(
      "resize",
      () => {
        refreshOffset();
      },
      { passive: true }
    );

    window.addEventListener(
      "load",
      () => {
        refreshOffset();
      },
      { once: true }
    );
  }

  const boot = () => {
    document.querySelectorAll("[data-cinematic-drop]").forEach(initDrop);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", boot);
})();
